import { render } from "./Table.vue?vue&type=template&id=48fa9627&ts=true"
import script from "./Table.vue?vue&type=script&setup=true&lang=ts"
export * from "./Table.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Shared/components/primitives/table/Table.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "48fa9627"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('48fa9627', __exports__)) {
    api.reload('48fa9627', __exports__)
  }
  
  module.hot.accept("./Table.vue?vue&type=template&id=48fa9627&ts=true", () => {
    api.rerender('48fa9627', render)
  })

}


export default __exports__